

export class featureGroupName {
    
    public static getUniqueName(newGroupName: string, existsNames: string[]): string {
        let uniqueName = newGroupName;
        let i = 2;
        while (existsNames.indexOf(uniqueName) !== -1) {
            uniqueName = newGroupName + ' (' + i + ')';
            i++;
        }
        return uniqueName;
    }
    
    
}